import { render, staticRenderFns } from "./truncated-chip-tooltip.vue?vue&type=template&id=62c2a3af"
import script from "./truncated-chip-tooltip.vue?vue&type=script&lang=js"
export * from "./truncated-chip-tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports